import { LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('badge-element')
export class BadgeElement extends LitElement {

	// Props
	@state()
	_slotNodes: Node[] = [];

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('Badge');

		// slots
		const slot: HTMLElement | null = this.querySelector('[slot="body"]');
		if (slot) {
			this._slotNodes = Array.from(slot.childNodes);
			this._slotNodes.forEach((node) => {
				this.appendChild(node);
			});
		}

		// observer
		document.addEventListener('navstuck', () => {
			this.classList.add('is-belowNav');
		});
		document.addEventListener('navunstuck', () => {
			this.classList.remove('is-belowNav');
		});
	}

	createRenderRoot() { 
		return this;
	}

}